import { Typography } from '@mui/material';

export default function PageTitle({ title }) {
  return (
    <Typography variant="h4" mt={2} mb={4}>{title}</Typography>
  )
}
